module.exports = {
      id: "calender-icon-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#calender-icon",
      toString: function () {
        return this.url;
      }
    }